export default "__VITE_ASSET__e5fa5f2b__"